<template>
    <div
        class="filters-pane-container flex-column flex ff-fix ov-reset"
        :class="{ 'is-setup': isSetup }"
    >
        <div class="pb-2 bb-1">
            <div class="flex-level no-shrink">
                <h3 class="flex my-0">
                    <span :class="{ grey: isAllFav }">{{ $l10n.__('Filtres') }}</span>
                    <span v-if="isAllFav && useFavorites"> - {{ $l10n.__('Favoris') }}</span>
                </h3>
                <CompassIconButton
                    icon="close"
                    @click="$store.dispatch(`${listinghash}/toggleDisplay`, 'filters')"
                />
            </div>

            <div
                v-if="isSetup || isAllFav || (isSelect && activeFilters.length)"
                class="flex-level no-shrink mt-2"
            >
                <div class="flex">
                    <CompassBackForwardButton
                        :label="$t.__('common.actions.back')"
                        link="#"
                        back
                        @click.prevent="back"
                    />
                </div>
                <CompassPlainButton
                    v-if="!isAllFav && !isSelect && useFavorites"
                    :label="$t.__('listing.FiltersPane.favorites')"
                    @click.prevent="udpateView('allFavoris')"
                />
            </div>
        </div>

        <div
            v-if="!isSetup && !isAllFav && useFavorites"
            class="flex-level mt-3 pb-1 no-shrink h-3"
        >
            <span class="flex fs-3 semibold gray-60">{{ $l10n.__('Favoris') }}</span>
            <CompassPlainButton
                v-if="!isAllFav"
                :label="$t.__('listing.FiltersPane.see_all')"
                @click.prevent="udpateView('allFavoris')"
            />
        </div>

        <div
            v-if="!isSetup && favoriteShortcuts.length && useFavorites"
            class="pb-3 bb-1"
            :class="{ 'mt-3': isAllFav }"
        >
            <ul class="m-0 shortcut-list">
                <favorite-item
                    v-for="shortcut in favoriteShortcuts"
                    :key="shortcut.id"
                    :favorite="shortcut"
                    :listinghash="listinghash"
                >
                </favorite-item>
            </ul>
        </div>

        <div v-if="isSummary" class="flex-column flex">
            <!-- PENDIND AND ACTIVE FILTER BLOCK -->
            <div class="filters_summary fs-3">
                <!-- TITLE AND RESET FILTER -->
                <div class="filters-active mt-3 mb-0 fs-3">
                    <template v-if="activeFilters.length">
                        <span class="semibold m-0">{{ $l10n.__('Filtres actifs') }}</span>
                        <!-- RESTET FILTER -->
                        <CompassButton
                            :label="$t.__('common.actions.reset')"
                            type="secondary"
                            size="small"
                            leftIcon="revert"
                            class="pull-right"
                            @click.prevent="resetFilters()"
                        />
                    </template>
                </div>

                <!-- ACTIVE FILTERS -->
                <ul class="graylist fs-3">
                    <li
                        v-for="activeFilter in activeFilters"
                        :key="activeFilter.name + '-active'"
                        class="flex-level mb-1 regular"
                    >
                        <span class="pointer flex" @click="setupFilter(activeFilter)">
                            {{ activeFilter.translation | shortText }}
                        </span>
                        <CompassIconButton
                            v-if="filterDeletable(activeFilter) && activeFilter.deletable"
                            icon="close"
                            variant="on-color"
                            @click.prevent="removeFilter(activeFilter)"
                        />
                    </li>
                </ul>

                <!-- APPLY FILTER -->
                <div class="mt-4 acenter">
                    <!-- ADD FILTER -->
                    <CompassButton
                        :label="$t.__('listing.FiltersPane.add_filter')"
                        type="primary"
                        @click="udpateView('select')"
                    />
                    <CompassButton
                        v-if="favoritesIsEditable && useFavorites"
                        :label="$t.__('listing.FiltersPane.save_as_favorite')"
                        type="secondary"
                        size="small"
                        leftIcon="star"
                        class="mt-3"
                        @click="$store.commit(`${listinghash}/showDisplay`, 'favoritesForm')"
                    />
                </div>

                <!-- PENDING FILTERS -->
                <div v-if="!!pendingFilters.length">
                    <p class="mt-3 mb-0 fs-3 semibold clearfix">
                        {{ $l10n.__('En attente') }}
                    </p>
                    <ul class="graylist fs-3">
                        <li
                            v-for="pendingFilter in pendingFilters"
                            :key="pendingFilter.name + '-pending'"
                            class="flex-level mb-1 regular"
                        >
                            <span class="pointer flex" @click="setupFilter(pendingFilter)">
                                {{ pendingFilter.translation | shortText }}
                            </span>
                            <CompassIconButton
                                v-if="filterEditable(pendingFilter)"
                                icon="close"
                                variant="on-color"
                                @click.prevent="
                                    $store.dispatch(`${listinghash}/removeFilter`, pendingFilter)
                                "
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- FILTER SEARCHBAR -->
        <div v-if="isSelect" class="form-group pt-3 mb-3 p-0 fs-3">
            <div class="form-input wp-10">
                <input
                    ref="searchfilter"
                    v-model="searchword"
                    type="text"
                    class="h-4 wp-10"
                    :placeholder="$t.__('listing.FiltersPane.search_filter')"
                />
            </div>
        </div>
        <!-- FILTER SEARCHBAR END -->

        <!-- NEW FILTERS -->
        <div v-if="isSelect" class="filters_select fs-3">
            <div class="filterList">
                <!-- NATIVE FILTER LIST -->
                <div v-if="nativeFilters.length > 0">
                    <h4 class="mt-0">{{ $l10n.__('Réguliers') }}</h4>
                    <ul class="filterSelector m-0">
                        <li
                            v-for="filter in nativeFilters"
                            :key="`${filter.name}-nativefilters`"
                            class="py-1 pointer availableFilter hover-primary-50"
                            :class="filter.active ? 'grey cursor-default' : filter.active"
                            @click="setupFilter(filter)"
                        >
                            <span
                                v-if="
                                    typeof filter.label === 'object' ||
                                    typeof filter.label === 'array'
                                "
                            >
                                {{ filter.label[0] }}
                            </span>
                            <span v-else>
                                {{ filter.label }}
                            </span>

                            <small v-if="filter.keywords" class="grey block">{{
                                filter.keywords
                            }}</small>
                        </li>
                    </ul>
                </div>

                <!-- CUSTOM FILTER LIST -->
                <div v-if="customFilters.length > 0">
                    <div v-for="category in customFilters" :key="category.title">
                        <h4>{{ $l10n.__('Champs personnalisés %s', category.title) }}</h4>

                        <ul class="filterSelector m-0">
                            <li
                                v-for="filter in category.filters"
                                :key="`${filter.name}-customfilters`"
                                class="py-1 pointer availableFilter hover-primary-50"
                                :class="filter.active ? 'grey cursor-default' : filter.active"
                                @click="setupFilter(filter)"
                            >
                                <badge dot inline tooltip :badges="getBadges(filter)">
                                    <span
                                        v-if="
                                            typeof filter.label === 'object' ||
                                            typeof filter.label === 'array'
                                        "
                                    >
                                        {{ filter.label[0] }}
                                    </span>
                                    <span v-else>
                                        {{ filter.label }}
                                    </span>
                                </badge>
                                <small v-if="filter.keywords" class="grey block">{{
                                    filter.keywords
                                }}</small>
                            </li>
                        </ul>
                    </div>
                </div>

                <p v-if="!nativeFilters.length && !customFilters.length" class="grey mt-0">
                    {{ $l10n.__('Aucun filtre trouvé') }}
                </p>
            </div>
        </div>
        <!-- NEW FILTERS END -->

        <!-- Favoris management -->
        <div v-if="isAllFav && useFavorites" class="pt-3 bt-1">
            <template>
                <el-tabs v-model="activeTab">
                    <el-tab-pane :label="$t.__('listing.FiltersPane.mine')" name="all">
                        <div class="form-group fs-3">
                            <div class="form-input wp-10">
                                <input
                                    ref="searchfavorites"
                                    v-model="searchwordFavoris"
                                    type="text"
                                    class="h-4 wp-10"
                                    :placeholder="$t.__('common.actions.search')"
                                />
                            </div>
                        </div>
                        <ul v-if="privateFavorites.length" class="favorite-list m-0 fs-3">
                            <favorite-item
                                v-for="favorite in privateFavorites"
                                :key="favorite.id"
                                v-model="favoriteid"
                                :favorite="favorite"
                                :listinghash="listinghash"
                                :update-mode="display.favoritesUpdate"
                            />
                        </ul>
                        <div
                            v-else-if="!privateFavorites.length && searchwordFavoris.length"
                            class="placeholder b-0"
                        >
                            {{ $l10n.__('Aucun favori trouvé') }}
                        </div>
                        <div v-else class="placeholder b-0">
                            {{ $l10n.__("Vous n'avez pas encore créé de favoris") }}
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t.__('listing.FiltersPane.shared_with_me')" name="shared">
                        <div class="form-group fs-3">
                            <div class="form-input wp-10">
                                <input
                                    ref="searchfilter"
                                    v-model="searchwordFavoris"
                                    type="text"
                                    class="h-4 wp-10"
                                    :placeholder="$t.__('common.actions.search')"
                                />
                            </div>
                        </div>
                        <ul v-if="sharedFavorites.length" class="favorite-list m-0 fs-3">
                            <favorite-item
                                v-for="favorite in sharedFavorites"
                                :key="favorite.id"
                                v-model="favoriteid"
                                :favorite="favorite"
                                :listinghash="listinghash"
                                :update-mode="display.favoritesUpdate"
                            />
                        </ul>
                        <div
                            v-else-if="!sharedFavorites.length && searchwordFavoris.length"
                            class="placeholder b-0"
                        >
                            {{ $l10n.__('Aucun favori partagé trouvé') }}
                        </div>
                        <div v-else class="placeholder b-0">
                            {{ $l10n.__('Aucun favori partagé') }}
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </template>
        </div>

        <listing-filter v-if="isSetup" :filter="currentFilter" @filter:apply="applyFilter" />
    </div>
</template>

<script>
import ListingFilter from './filters/ListingFilter.vue';
import _ from 'lodash';
import { removeAccents } from 'Core/commons/Utilities';
import FavoriteItem from './favorites/FavoriteItem.vue';
import Badge from 'vcomponents/utilities/Badge.vue';
import TagHumansConfig from 'Config/authenticated/TagHumans';

import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('user');

export default {
    components: {
        ListingFilter,
        FavoriteItem,
        Badge,
    },

    props: {
        listinghash: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            prevFiltersView: '',
            currentFilter: false,
            searchword: '',
            searchwordFavoris: '',
            activeTab: 'all',
            favoriteid: '',
            loading: false,
        };
    },

    computed: {
        isAllFav() {
            return this.display.filtersView === 'allFavoris';
        },
        isSetup() {
            return this.display.filtersView === 'setup';
        },
        isSummary() {
            return this.display.filtersView === 'summary';
        },
        isSelect() {
            return this.display.filtersView === 'select';
        },
        filters() {
            return this.$store.state[this.listinghash].filters;
        },

        ...mapState({
            userId: 'id',
        }),

        display() {
            return this.$store.state[this.listinghash].display;
        },

        displayFilter() {
            return this.$store.state[this.listinghash].display.filters;
        },

        savedSearchUrl() {
            return this.$store.state[this.listinghash].savedSearchesUrl;
        },

        hasActiveFilters() {
            return this.$store.getters[this.listinghash + '/activeFilters'].length > 0;
        },

        activeFilters() {
            return this.$store.getters[this.listinghash + '/activeFilters'];
        },

        topFilters() {
            return this.$store.getters[this.listinghash + '/topFilters'];
        },

        pendingFilters() {
            return this.$store.getters[this.listinghash + '/pendingFilters'];
        },

        nativeFilters() {
            let filtered = Object.values(this.filters);

            if (this.searchword !== '') {
                var regexp = new RegExp(removeAccents(this.searchword), 'i');

                filtered = Object.values(this.filters).filter((filter) => {
                    let filterlabel = filter.label;

                    if (typeof filterlabel !== 'string') {
                        filterlabel = filter.label[0];
                    }

                    return (
                        regexp.test(removeAccents(filterlabel)) ||
                        regexp.test(removeAccents(filter.keywords))
                    );
                });
            }

            // Split native fields from customfields using filter on name pattern
            // Then order them alphabetically

            return filtered
                .filter((one) => {
                    return !one.customfield;
                })
                .sort(function (a, b) {
                    if (a.label < b.label) return -1;
                    if (a.label > b.label) return 1;
                    return 0;
                });
        },

        customFilters() {
            let filtered = Object.values(this.filters);

            if (this.searchword !== '') {
                var regexp = new RegExp(removeAccents(this.searchword), 'i');

                filtered = Object.values(this.filters).filter((filter) => {
                    let filterlabel = filter.label;
                    if (typeof filterlabel !== 'string') {
                        filterlabel = filter.label[0];
                    }
                    return (
                        regexp.test(removeAccents(filterlabel)) ||
                        regexp.test(removeAccents(filter.keywords))
                    );
                });
            }

            const categories = _.uniq(
                filtered
                    .map((one) => {
                        return one.customfieldcategory ? one.customfieldcategory : '';
                    })
                    .filter((one) => {
                        return one !== '';
                    }),
            );

            const categorizedFilters = [];
            for (const i in categories) {
                const filters = filtered
                    .filter((one) => {
                        return one.customfield && one.customfieldcategory === categories[i];
                    })
                    .sort(function (a, b) {
                        if (a.label < b.label) return -1;
                        if (a.label > b.label) return 1;
                        return 0;
                    });

                if (filters.length) {
                    categorizedFilters.push({
                        title: categories[i].toLowerCase(),
                        filters: filters,
                    });
                }
            }

            return categorizedFilters;
        },

        permissions() {
            return this.$store.state[this.listinghash].permissions;
        },

        favoriteShortcuts() {
            return this.$store.getters[`${this.listinghash}/favoriteShortcuts`]
                .slice()
                .sort((a, b) => a.name.localeCompare(b.name));
        },

        favorites() {
            return this.$store.state[this.listinghash].favorites;
        },

        privateFavorites() {
            const privateFav = this.favorites.filter((itm) => {
                return itm.ownerid === this.userId;
            });

            let favorites = Object.values(privateFav);

            if (this.searchwordFavoris !== '') {
                favorites = this.getFavoritesFiltered(privateFav);
            }

            return favorites;
        },

        sharedFavorites() {
            const sharedFav = this.favorites.filter((itm) => {
                return itm.ownerid !== this.userId;
            });

            let favorites = Object.values(sharedFav);

            if (this.searchwordFavoris !== '') {
                favorites = this.getFavoritesFiltered(sharedFav);
            }

            return favorites;
        },

        favoritesIsEditable() {
            return this.$store.state[this.listinghash].permissions.favorite;
        },

        useFavorites() {
            return this.$store.state[this.listinghash].useFavorites;
        },
    },

    watch: {
        displayFilter: function () {
            if (this.activeFilters.length === 0) {
                this.udpateView('select');
            }
        },
    },

    created() {
        EventBus.$on(
            'filters:edit',
            function (filter) {
                this.setupFilter(filter);
            }.bind(this),
        );
    },

    methods: {
        filterEditable(filter) {
            return !_.has(this.$store.state[this.listinghash].prefilter, filter.name);
        },

        filterDeletable(filter) {
            return (
                !_.has(this.$store.state[this.listinghash].prefilter, filter.name) &&
                filter.deletable
            );
        },

        getFavoritesFiltered(favorites) {
            var regexp = new RegExp(removeAccents(this.searchwordFavoris), 'i');

            return Object.values(favorites).filter((filter) => {
                let favoriteName = filter.name;

                if (typeof favoriteName !== 'string') {
                    favoriteName = filter.name[0];
                }

                return regexp.test(removeAccents(favoriteName));
            });
        },

        // Navigation
        udpateView(view) {
            this.prevFiltersView = this.display.filtersView;

            this.$store.commit(`${this.listinghash}/updateFiltersView`, view);

            if (view === 'select') {
                this.searchword = '';
                this.$nextTick(() => this.$refs.searchfilter.focus());
            }
        },

        back() {
            if (this.prevFiltersView === 'allFavoris' && this.isSetup) {
                this.prevFiltersView = 'select';
            }

            this.udpateView(this.prevFiltersView);
        },

        setupFilter(filter) {
            if (!this.filterEditable(filter)) {
                return;
            }

            this.currentFilter = filter;
            this.udpateView('setup');
        },

        applyFilter(payload) {
            this.$store.commit(`${this.listinghash}/applyFilter`, payload.filter);

            if (payload.addNew) {
                this.udpateView('select');
            } else {
                this.applyFilters();
                this.udpateView('summary');
            }
        },

        // Events to apply filter & update listing
        applyFilters() {
            this.$store.dispatch(`${this.listinghash}/fetch`);
        },
        permissionDenied() {
            this.$store.dispatch(`${this.listinghash}/permissionDenied`);
        },
        resetFilters() {
            this.$store.dispatch(`${this.listinghash}/resetFilters`);
        },
        removeFilter(activeFilter) {
            this.$store.dispatch(`${this.listinghash}/removeFilter`, activeFilter);
            if (this.activeFilters.length === 0) {
                this.udpateView('select');
            }
        },

        /**
         * TODO: see if possible to refacto methode => also exist (ListingColumns.vue)
         * Filter on TagHumansConfig only tagHuman who match with relationTypes passed in parameters
         *
         * @param {{name: String}} {more} - prop of filter, particulary "more" of filter who contain "useOn[]"
         * @return {Object[]} Return an array of tagHumans
         */
        getBadges({ more }) {
            const relationTypes = more ? more.useOn : [];

            return Object.entries(TagHumansConfig)
                .map(([id, tag]) => ({ id, ...tag })) // instruction can be remove if we add directly id for each tag human
                .filter(({ id }) => relationTypes.includes(id));
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';

.filters {
    &-pane-container:not(.is-setup) {
        min-height: min-content;
    }

    &_select {
        overflow-y: auto;
    }

    &-active {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}
</style>
